import './App.css';
import NavAuth from './Components/NavAuth';
import { Route, Routes } from 'react-router-dom';

import Register from './Components/Register';
import Login from './Components/Login';

import PrivateRoute from './Components/PrivateRoute';
import Errors from './Components/Errors';
import ListUser from './Components/ListUser';
import UpdateUser from './Components/UpdateUser';
import UpdateProfil from './Components/UpdateProfil';

import Rapports from './Components/Rapports';

import ApplicationFakhry from './Components/ApplicationFakhry';




import Welcome from './Components/Welcome';
import RapportsSpintoss from './Components/RapportsSpintoss';
import ListRapportsSpintoss from './Components/ListRapportsSpintoss';
import Accueil from './Components/Accueil';
import ChargeExp from './Components/ChargeExp';


import Menu from './Components/Menu';
import Addition from './Components/Addition';
import BillsFilter from './Components/BillsFilter';
import UpdateStock from './Components/UpdateStock';
import Deals from './Components/Deals';
import Valises from './Components/Valises';
import ProductValises from './Components/ProductValises';
import IngredientFormV from './Components/IngredientFormV';
import InvoiceVForm from './Components/InvoiceVForm';
import SupplierVForm from './Components/SupplierVForm';
import StockReportV from './Components/StockReportV';
import RealStock from './Components/RealStock';
import DealsV from './Components/DealsV';
import InvoiceVList from './Components/InvoiceVList';
import TicketCaisse from './Components/TicketCaisse';
import Marge from './Components/Marge';
import InvoiceDocList from './Components/InvoiceDocList';
import UploadInvoice from './Components/UploadInvoice';
import InvoiceView from './Components/InvoiceView';
import UpdateProduct from './Components/UpdateProduct';
import StockDetails from './Components/StockDetails';
import UpdateStockV from './Components/UpdateStockV';
import ChangeLocation from './Components/ChangeLocation';
import Event from './Components/Event';
import PackManagement from './Components/PackManagement';
import CheckInSystem from './Components/CheckInSystem';
import SubscribersList from './Components/SubscribersList';
import ProductRequestForm from './Components/ProductRequestForm';
import CentralizedRequests from './Components/CentralizedRequests';
import AdminApproval from './Components/AdminApproval';
import PurchaseList from './Components/PurchaseList';
import CategoryProductManager from './Components/CategoryProductManager.js';
import GlobalDashboard from './Components/GlobalDashboard.js';
import StaffCReport from './Components/StaffCReport.js';
import SalonBookingModule from './Components/SalonBookingModule.js';
import BookingCalendar from './Components/Booking/BookingCalendar.js';
import BookingHistory from './Components/Booking/BookingHistory.js';
import ServiceManager from './admin/ServiceManager.js';
import PointsGestion from './Components/PointsGestion.js';





function App() {

  return (
    <div>

      <NavAuth />
      <Errors />
      <Routes>


        <Route path='/Accueil' element={<Accueil />} />
        <Route path='/Welcome' element={<Welcome />} />
        <Route path='/Register' element={<Register />} />
        <Route path='/Login' element={<Login />} />
        <Route path='/AllUser' element={<ListUser />} />
        <Route path='/UpdateUser/:id' element={<UpdateUser />} />
        <Route path='/UpdateProfil' element={<UpdateProfil />} />
        <Route path='/AddRapports' element={<Rapports />} />
        <Route path='/ApplicationFakhry' element={<ApplicationFakhry />} />
        <Route path='/AddRapportsSpintoss' element={<RapportsSpintoss />} />
        <Route path='/ListRapportsSpintoss' element={<ListRapportsSpintoss />} />
        <Route path='/AddChargeExp' element={<ChargeExp />} />
        <Route path='/AjoutFrsV' element={<SupplierVForm />} />
        <Route path='/AjoutArticle' element={<IngredientFormV />} />
        <Route path='/TicketCaisse' element={<TicketCaisse />} />
        <Route path='/AjoutFactureV' element={<InvoiceVForm />} />
        <Route path='/ApercuStock' element={<StockReportV />} />
        <Route path='/ListProduct' element={<Menu />} />
        <Route path='/Addition' element={<Addition />} />
        <Route path='/TicketReport' element={<BillsFilter />} />
        <Route path='/UpdateStock' element={<UpdateStock />} />
        <Route path='/Deals' element={<Deals />} />
        <Route path='/DealsV' element={<DealsV />} />
        <Route path='/Valises' element={<Valises />} />
        <Route path='/CreaValises' element={<ProductValises />} />
        <Route path='/RealStock' element={<RealStock />} />
        <Route path='/ListFactureV' element={<InvoiceVList />} />
        <Route path='/MargeState' element={<Marge />} />
        <Route path='/UploadInvoice' element={<UploadInvoice />} />
        <Route path='/InvoiceDocList' element={<InvoiceDocList />} />
        <Route path='/InvoiceView' element={<InvoiceView />} />
        <Route path='/UpdateProduct' element={<UpdateProduct />} />
        <Route path='/StockDetails' element={<StockDetails />} />
        <Route path='/UpdateStockV' element={<UpdateStockV />} />
        <Route path='/ChangeLocation' element={<ChangeLocation />} />
        <Route path='/Event' element={<Event />} />
        <Route path='/Pack' element={<PackManagement />} />
        <Route path='/Checkin' element={<CheckInSystem />} />
        <Route path='/SubscribersList' element={<SubscribersList />} />
        <Route path='/ProductRequest' element={<ProductRequestForm />} />
        <Route path='/CentralizedRequests' element={<CentralizedRequests />} />
        <Route path='/AdminApproval' element={<AdminApproval />} />
        <Route path='/PurchaseList' element={<PurchaseList />} />
        <Route path='/CategoryProductManager' element={<CategoryProductManager />} />
        <Route path='/GlobalDashbord' element={<GlobalDashboard />} />
        <Route path='/ticketpersonnel' element={<StaffCReport />} />
        <Route path='/SalonBookingModule' element={<SalonBookingModule />} />
        <Route path='/BookingCalendar' element={<BookingCalendar />} />
        <Route path='/BookingHistory' element={<BookingHistory />} />
        <Route path='/ServiceManager' element={<ServiceManager />} />
        <Route path='/PointsGestionT' element={<PointsGestion />} />





      </Routes>

    </div>
  );
}

export default App;
